import { render } from "./DiagnosisCombobox.vue?vue&type=template&id=1f479a02&scoped=true"
import script from "./DiagnosisCombobox.vue?vue&type=script&lang=js"
export * from "./DiagnosisCombobox.vue?vue&type=script&lang=js"

import "./DiagnosisCombobox.vue?vue&type=style&index=0&id=1f479a02&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f479a02"]])

export default __exports__